import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import "./shared/i18n";
import "./index.css";

// ============================================
// Telegram WebApp initialization
// ============================================

function applyTheme(colorScheme: "light" | "dark" | undefined) {
  document.documentElement.classList.toggle("dark", colorScheme === "dark");
}

if (window.Telegram?.WebApp) {
  window.Telegram.WebApp.expand();
  window.Telegram.WebApp.ready();

  applyTheme(window.Telegram.WebApp.colorScheme);

  window.Telegram.WebApp.onEvent("themeChanged", () => {
    applyTheme(window.Telegram?.WebApp.colorScheme);
  });
} else if (
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches
) {
  applyTheme("dark");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
